/** biome-ignore-all lint/suspicious/noConsole: <explanation> */

import { useTranslation } from '@cobliteam/i18n';
import { OramaClient } from '@oramacloud/client';
import { useCallback, useEffect, useState } from 'react';
import globalSidebarDef from '../globalSidebarDef';
import { type ArticleWithCategory, EnumCategory } from '../types';

const oramaSuporteHost = 'https://cloud.orama.run/v1/indexes/suporte-sveik3';
const oramaSuporteApiKey = 'eQYwWDHsMywyH4BNPNCaTidQ3FSHrka1';

const oramaCobliWebsiteHost = 'https://cloud.orama.run/v1/indexes/cobli-co-m4wlqy';
const oramaCobliWebsiteApiKey = 'Ah7FMkvVJJ5hYNcw6qoLxXAny5HCCeBq';

const oramaClient = new OramaClient({
  mergeResults: true,
  indexes: [
    {
      api_key: oramaSuporteApiKey,
      endpoint: oramaSuporteHost,
    },
    {
      api_key: oramaCobliWebsiteApiKey,
      endpoint: oramaCobliWebsiteHost,
    },
  ],
});

export type Nullable<T> = T | null;

const useFetchArticles = ({ search, limit }: { search: string; limit?: number }) => {
  const [results, setResults] = useState<ArticleWithCategory[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation('global-search');

  const fetchOrama = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await oramaClient.search({
        term: search,
        limit: limit || undefined,
        mode: 'fulltext',
      });

      if (!results) return;

      const groupCategory = globalSidebarDef(t).find((category) => category.categories.find((c) => c.id === EnumCategory.ARTICLES));
      const category = groupCategory?.categories.find((c) => c.id === EnumCategory.ARTICLES);

      const oramaResults =
        response?.hits.map((result) => {
          return { ...result.document, category, categoryOrama: result.document.category };
        }) || [];

      setResults(oramaResults);
    } catch (error) {
      console.error('Error fetching articles:', error);
    } finally {
      setIsLoading(false);
    }
  }, [search, limit]);

  useEffect(() => {
    fetchOrama();
  }, [fetchOrama]); // Change dependency to actual changing values

  return { results, isLoading };
};

export default useFetchArticles;
